import { useState, forwardRef, useRef, useImperativeHandle } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, isFunction } from 'lodash';
import Icon from '../../Icon/Icon';

const Search = forwardRef((props, ref) => {
  const [value, setValue] = useState('');
  const searchRef = useRef(null);
  const onChange = (event) => {
    setValue(event.target.value);
    if (isFunction(props.onChange)) {
      props.onChange(event.target.value);
    }
  }

  const resetValue = () => {
    setValue('');
    if (isFunction(props.onChange)) {
      props.onChange('');
    }
  }

  useImperativeHandle(ref, () => (
    {
      onChange(e) {
        onChange(e)
      },
      resetValue() {
        resetValue()
      },
    }
  ), []);
 
  return (
    <div className="relative leading-none">
      <label
        htmlFor={props.id}
        className="absolute w-px h-px p-0 m-[-1px] overflow-hidden border-0"
        ref={searchRef}
      >
        {props.label}
      </label>

      <input
        id={props.id}
        className="bg-light-border-grey border-solid rounded-t border-b border-t border-light-border-blue block m-0 p-2.5 relative w-full
        placeholder-placeholder-blue text-sm text-text-blue font-arial-font focus:outline-none"
        type="text"
        onChange={onChange}
        value={value}
        placeholder={props.placeholder}
      />

      <div className="absolute right-4 top-4 transform -translate-y-1/2 outline-none mt-0.5">
        {
          isEmpty(value) ?
            <Icon icon="Search" size={12} color='medium-grey' /> :
            <Icon icon="Cross" size={12} color='medium-grey' onClick={resetValue} />
        }
      </div>
    </div>
  );
}
)

Search.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired,
};

export default Search;
